import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DefaultService } from 'src/app/core/framework/default-service';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { DateTimeUtil } from 'src/app/core/framework/utils/date-time-util';
import { CfgIntegracaoEventoLog } from '../cfg-integracao-evento-log/model/cfg-integracao-evento-log.model';


@Injectable({
  providedIn: 'root'
})
export class CfgIntegracaoEventoLogService extends DefaultService<CfgIntegracaoEventoLog> {
  static URL = '/api/cfgintegracao/cfgintegracaoeventolog/v1/cfgintegracaoeventolog';

  private dateTimeUtil = new DateTimeUtil();

  constructor(
    public httpClient: HttpClient,
    public errorHandlerService: ErrorHandlerService,
  ) {
    super(
      httpClient,
      errorHandlerService,
      CfgIntegracaoEventoLogService.URL
    );
  }

  public dashConsumoPorIntegracao(dataInicio: Date, dataFim: Date): Observable<any> {
    const dataInicioStr = this.dateTimeUtil.dateToIsoFormat(dataInicio);
    const dataFimStr = this.dateTimeUtil.dateToIsoFormat(dataFim);

    return this.httpClient.get<any>(`${CfgIntegracaoEventoLogService.URL}/dashConsumoPorIntegracao?dataInicio=${dataInicioStr}&dataFim=${dataFimStr}`, this.httpOptions)
                          .pipe(
                            catchError((err: any) => {
                              this.errorHandlerService.handle(err);
                              return throwError(err);
                            })
                          );
  }

  public dashFalhasPorIntegracao(dataInicio: Date, dataFim: Date): Observable<any> {
    const dataInicioStr = this.dateTimeUtil.dateToIsoFormat(dataInicio);
    const dataFimStr = this.dateTimeUtil.dateToIsoFormat(dataFim);

    return this.httpClient.get<any>(`${CfgIntegracaoEventoLogService.URL}/dashFalhasPorIntegracao?dataInicio=${dataInicioStr}&dataFim=${dataFimStr}`, this.httpOptions)
                          .pipe(
                            catchError((err: any) => {
                              this.errorHandlerService.handle(err);
                              return throwError(err);
                            })
                          );
  }
}
